// eslint-disable-next-line import/no-cycle
import { setArchivedListFailed, setArchivedListPending, setArchivedListSucceed } from './actions';
import { IArchivedListRequest } from './types';
import { transformItemListChatV1 } from '../../mappers/transformItemListChatV1';
import { isShowSubAgentChatListSelector } from '../../selectors';
// eslint-disable-next-line import/no-cycle
import { fetchArchivedChats } from '../../services/chatsList';
import { TChatInListSchema, CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { isChatsV2Enabled } from '../../utils/isChatsV2Enabled';
import { setRoute } from '../route';
import { getArchivedChatsV2 } from './getArchivedChatsV2';

/**
 * Получить список архивных чатов
 */
export const getArchivedChats =
  ({ timestampArchive }: IArchivedListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const isChatsV2 = isChatsV2Enabled(context.config);

    if (isChatsV2) {
      dispatch(getArchivedChatsV2({ timestampArchive }));

      return;
    }

    const {
      chatList,
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setArchivedListPending({ timestampArchive }));

    const archivedChats = await fetchArchivedChats(context, {
      parameters: {
        limit: CHATS_ON_PAGE_LIMIT,
        timestampMs: timestampArchive,
        subAgentRealtyUserId,
      },
    });

    if (archivedChats === null) {
      dispatch(setArchivedListFailed());

      return;
    }

    // FIXME: хз, что здесь происходит
    const archivedChatsVisible =
      chatList.chats.filter((chat: TChatInListSchema) => chat.archived).length + archivedChats.length;

    const chats = archivedChatsVisible ? archivedChats.map(transformItemListChatV1) : [];

    dispatch(setArchivedListSucceed({ chats }));

    /**
     * Ставим активный пункт меню - спам и сбрасываем восстановленный id из архива,
     * чтобы обнулить открытый чат при переходе в архив.
     */
    dispatch(
      setRoute({ route: ERoute.Archive, cleanRemovedFromArchiveChatId: true, cleanRemovedFromSpamChatId: true }),
    );
  };
